import React, { useState } from 'react';

const FoodItemInput = ({ value = [], onChange }) => {
  const [currentFood, setCurrentFood] = useState('');
  const [currentCategory, setCurrentCategory] = useState('');

  const foodCategories = [
    'Dairy',
    'Gluten', 
    'Vegetable',
    'Meat',
    'Fruit',
    'Drink',
    'Snack',
    'Other'
  ];

  const addFoodItem = () => {
    if (currentFood.trim()) {
      const newItem = {
        name: currentFood.trim(),
        category: currentCategory || 'Other'
      };
      
      const updatedItems = [...value, newItem];
      onChange(updatedItems);
      
      // Reset inputs
      setCurrentFood('');
      setCurrentCategory('');
    }
  };

  const removeFoodItem = (index) => {
    const updatedItems = value.filter((_, i) => i !== index);
    onChange(updatedItems);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addFoodItem();
    }
  };

  return (
    <div className="space-y-4">
      {/* Add new food item */}
      <div className="border border-gray-300 rounded-lg p-4 bg-white bg-opacity-50 backdrop-blur-sm">
        <div className="flex flex-col sm:flex-row gap-3">
          <div className="flex-1">
            <input
              type="text"
              value={currentFood}
              onChange={(e) => setCurrentFood(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter food or drink..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            />
          </div>
          
          <div className="sm:w-40">
            <select
              value={currentCategory}
              onChange={(e) => setCurrentCategory(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            >
              <option value="">Category...</option>
              {foodCategories.map(category => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
          
          <button
            type="button"
            onClick={addFoodItem}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium"
          >
            Add
          </button>
        </div>
      </div>

      {/* Display added food items as tags */}
      {value.length > 0 && (
        <div className="space-y-2">
          <p className="text-sm font-medium text-gray-700">Added foods:</p>
          <div className="flex flex-wrap gap-2">
            {value.map((item, index) => (
              <div
                key={index}
                className="inline-flex items-center gap-2 px-3 py-1 bg-blue-100 text-blue-800 rounded-lg text-sm"
              >
                <span className="font-medium">{item.name}</span>
                <span className="text-xs bg-blue-200 px-2 py-0.5 rounded">
                  {item.category}
                </span>
                <button
                  type="button"
                  onClick={() => removeFoodItem(index)}
                  className="text-blue-600 hover:text-red-600 transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FoodItemInput;